import { GridColDef } from "@mui/x-data-grid";

export const workOrderRoleTitleColumns: GridColDef[] = [
  { field: "name", headerName: "Name", flex: 1 },
];
